import React from "react";
const EditContext = React.createContext(null);

export default EditContext;
